import { usePersistentState } from '@cast/utils';

const STORAGE_KEY_PREFIX = 'explore-automation-banner-dismissed';

export const getExploreAutomationBannerDismissKey = (
  organizationId: string
): string => `${STORAGE_KEY_PREFIX}:${organizationId}`;

export const useExploreAutomationBannerDismiss = (
  organizationId: string | undefined
) => {
  const key = getExploreAutomationBannerDismissKey(organizationId ?? 'unknown');
  const [dismissed, setDismissed] = usePersistentState<boolean>(key, false);

  return {
    isDismissed: !!organizationId && dismissed,
    dismiss: () => setDismissed(true),
  };
};
